export default __webpack_public_path__ + "static/media/solucao-03.72f380cb.webp";